import { render, staticRenderFns } from "./zhixingsf.vue?vue&type=template&id=501e97b2"
import script from "./zhixingsf.vue?vue&type=script&lang=ts"
export * from "./zhixingsf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports